import { render, staticRenderFns } from "./AddAbsenceItemPage.vue?vue&type=template&id=0c1f9ca3&scoped=true&"
import script from "./AddAbsenceItemPage.vue?vue&type=script&lang=js&"
export * from "./AddAbsenceItemPage.vue?vue&type=script&lang=js&"
import style0 from "./AddAbsenceItemPage.vue?vue&type=style&index=0&id=0c1f9ca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f9ca3",
  null
  
)

export default component.exports